import type { FC } from "react";
import type { InputProps } from "~/utils/types";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "../ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { useTranslation } from "react-i18next";

const SelectFormInput: FC<InputProps & { getValueId?: (value: any) => any; tabIndex?: number }> = ({
  name,
  label,
  helperText,
  options = [],
  onChange,
  tabIndex,
}) => {
  const { t } = useTranslation();

  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormItem className="max-w-[600px]">
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange({
                target: {
                  value: e,
                },
              });
              onChange?.(e);
            }}
            value={field.value ? field.value : ""}
          >
            <FormControl tabIndex={tabIndex}>
              <SelectTrigger>
                <SelectValue placeholder={t("Wählen Sie eine Option")} />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="z-50">
              {options.map((o) => (
                <SelectItem key={o.value} value={o.value}>
                  {o.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {helperText && <FormDescription>{helperText}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export { SelectFormInput };
